import React from 'react';
import Box from '../../components/Box/Box';
import { TextBodySmall } from '../../components/Text';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TListBase } from './types';

const ListBase = ({ as, kind, title, children, ...rest }: TListBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return (
    <Box {...conditionalProps} as={as} name="List" {...rest}>
      {title && <TextBodySmall color="text-secondary">{title}</TextBodySmall>}
      {children}
    </Box>
  );
};

export default ListBase;
